// import { Fragment, useEffect, useState } from "react";
// import { DeleteOutline } from "@mui/icons-material";
// import { Button, Grid, IconButton, Tooltip, Typography } from "@mui/material";

// import { colors } from "../../css components/Style";
// import { ComponentHeader, Paper, TextField } from "../../../components";

// export default function FormThree({
//   state,
//   dispatch,
//   editState,
//   disaptchMessage,
// }) {
//   const [message, setMessage] = useState({ additionalFields: [] });
//   const [inputValue, setInputValue] = useState({ additionalFields: [] });

//   useEffect(() => {
//     if (state["additionalFields"]) {
//       setInputValue((prev) => ({
//         ...prev,
//         additionalFields: state["additionalFields"],
//       }));
//       // initialize empty messages array with same length
//       setMessage({
//         additionalFields: new Array(state["additionalFields"].length).fill(""),
//       });
//     }
//   }, [state]);

//   function handleFieldChange(value, name) {
//     // validate all fields

//     inputValue.additionalFields.forEach((_, index) => {
//       checkValidation(index, name);
//     });

//     // if no errors, update state
//     if (message.additionalFields.every((msg) => msg === "")) {
//       dispatch({
//         type: "ADDITIONAL_FIELDS",
//         payload: { value, name },
//       });
//     }
//   }

//   function checkValidation(index, name) {
//     const field = inputValue.additionalFields[index];
//     let errorMsg = "";

//     if (!field?.key || !field?.value) {
//       errorMsg = "Please fill the values or delete the field.";
//     }

//     setMessage((prev) => {
//       const updated = [...prev.additionalFields];
//       if (errorMsg) {
//         updated[index] = errorMsg;
//       } else {
//         updated.splice(index, 1);
//       }
//       const newMessage = { additionalFields: updated };
//       disaptchMessage({
//         type: "MESSAGE_UPDATE",
//         payload: {
//           value: updated.length > 0 ? newMessage : {},
//           key:
//             updated.length > 0
//               ? `additionalFields.${index}`
//               : "additionalFields",
//         },
//       });

//       return newMessage;
//     });
//   }

//   function handleDelete(index) {
//     // remove field
//     const fields = [...inputValue.additionalFields];
//     fields.splice(index, 1);

//     const msgs = [...message.additionalFields];
//     msgs.splice(index, 1);

//     setInputValue({ additionalFields: fields });
//     setMessage({ additionalFields: msgs });

//     dispatch({
//       type: "ADDITIONAL_FIELDS",
//       payload: { value: fields, name: "additionalFields" },
//     });
//     disaptchMessage({
//       type: "MESSAGE_UPDATE",
//       payload: {
//         value: msgs.length > 0 ? { additionalFields: msgs } : {},
//         key: "additionalFields",
//       },
//     });
//   }

//   function handleAddFields() {
//     let addField = true;
//     let emptyIndex = -1;

//     // find first empty field
//     inputValue.additionalFields.forEach((field, index) => {
//       if ((!field.key || !field.value) && emptyIndex === -1) {
//         emptyIndex = index;
//         addField = false;
//       }
//     });

//     if (addField) {
//       // all fields filled → add new field
//       const newFields = [
//         ...inputValue.additionalFields,
//         { key: "", value: "" },
//       ];

//       const newMessages = [...message.additionalFields, ""];

//       setInputValue({ additionalFields: newFields });
//       setMessage({ additionalFields: newMessages });
//     } else {
//       // some field is empty → show error for that exact field
//       setMessage((prev) => {
//         const updated = [...prev.additionalFields];
//         updated[emptyIndex] =
//           "Please fill this field before adding another one.";
//         return { additionalFields: updated };
//       });
//     }
//   }

//   return (
//     <Paper>
//       <Grid size={12}>
//         <ComponentHeader
//           title={"Additional Field"}
//           subtitle={"Not able to find desired audience field? Add them."}
//           buttons={[
//             <Button
//               onClick={handleAddFields}
//               variant="contained"
//               disabled={!editState}
//             >
//               Add Additional Field
//             </Button>,
//           ]}
//         />
//       </Grid>

//       {inputValue.additionalFields.map((_, index) => (
//         <Fragment key={index}>
//           <Grid size={10}>
//             <Typography variant="h6">
//               {"Additional Field " + (index + 1)}
//             </Typography>
//           </Grid>

//           <Grid size={5}>
//             <TextField
//               size="small"
//               value={inputValue.additionalFields?.[index]?.key}
//               disabled={!editState}
//               placeholder="Key"
//               label="Key"
//               onBlur={() =>
//                 handleFieldChange(
//                   inputValue.additionalFields,
//                   "additionalFields"
//                 )
//               }
//               onChange={(e) => {
//                 const newFields = [...inputValue.additionalFields];
//                 newFields[index] = {
//                   ...newFields[index],
//                   key: e.target.value,
//                 };
//                 setInputValue({ additionalFields: newFields });
//                 checkValidation(index, "additionalFields");
//               }}
//             />
//           </Grid>

//           <Grid size={5}>
//             <TextField
//               size="small"
//               value={inputValue.additionalFields?.[index]?.value}
//               disabled={!editState}
//               placeholder="Value"
//               label="Value"
//               onBlur={() =>
//                 handleFieldChange(
//                   inputValue.additionalFields,
//                   "additionalFields"
//                 )
//               }
//               onChange={(e) => {
//                 const newFields = [...inputValue.additionalFields];
//                 newFields[index] = {
//                   ...newFields[index],
//                   value: e.target.value,
//                 };
//                 setInputValue({ additionalFields: newFields });
//                 checkValidation(index, "additionalFields");
//               }}
//             />
//           </Grid>

//           {editState && (
//             <Grid size={2} alignSelf={"center"}>
//               <Tooltip title={"Delete additional field " + (index + 1)}>
//                 <IconButton
//                   style={{ color: colors.error }}
//                   onClick={() => handleDelete(index)}
//                 >
//                   <DeleteOutline />
//                 </IconButton>
//               </Tooltip>
//             </Grid>
//           )}

//           <Grid size={12}>
//             <Typography variant="caption" color={colors.error}>
//               {message.additionalFields[index]}
//             </Typography>
//           </Grid>
//         </Fragment>
//       ))}
//     </Paper>
//   );
// }

import { Fragment, useEffect, useState } from "react";
import { DeleteOutline } from "@mui/icons-material";
import { Button, Grid, IconButton, Tooltip, Typography } from "@mui/material";

import { colors } from "../../css components/Style";
import { ComponentHeader, Paper, TextField } from "../../../components";

export default function FormThree({
  state,
  dispatch,
  editState,
  disaptchMessage,
}) {
  const [message, setMessage] = useState({ additionalFields: [] });
  const [inputValue, setInputValue] = useState({ additionalFields: [] });

  // ----------------------------
  // INIT VALUES FROM REDUX
  // ----------------------------
  useEffect(() => {
    if (state["additionalFields"]) {
      setInputValue({
        additionalFields: state["additionalFields"],
      });

      setMessage({
        additionalFields: new Array(state["additionalFields"].length).fill(""),
      });
    }
  }, [state]);

  // ----------------------------
  // VALIDATION FOR A SINGLE FIELD
  // ----------------------------
  function checkValidation(index) {
    const field = inputValue.additionalFields[index];
    let errorMsg = "";

    if (!field?.key || !field?.value) {
      errorMsg = "Please fill the values or delete the field.";
    }

    setMessage((prev) => {
      const updated = [...prev.additionalFields];
      updated[index] = errorMsg;

      const newMessage = { additionalFields: updated };

      disaptchMessage({
        type: "MESSAGE_UPDATE",
        payload: {
          value: updated.some((msg) => msg !== "") ? newMessage : {},
          key: updated.some((msg) => msg !== "")
            ? `additionalFields.${index}`
            : "additionalFields",
        },
      });

      return newMessage;
    });

    return errorMsg === "";
  }

  // ----------------------------
  // UPDATE REDUX ON BLUR
  // ----------------------------
  function handleBlur() {
    const allValid = inputValue.additionalFields.every((f) => f.key && f.value);

    // If all fields are valid → update redux
    if (allValid) {
      dispatch({
        type: "ADDITIONAL_FIELDS",
        payload: {
          value: inputValue.additionalFields,
          name: "additionalFields",
        },
      });
    }
  }

  // ----------------------------
  // DELETE FIELD
  // ----------------------------
  function handleDelete(index) {
    const newFields = [...inputValue.additionalFields];
    newFields.splice(index, 1);

    const newMsgs = [...message.additionalFields];
    newMsgs.splice(index, 1);

    setInputValue({ additionalFields: newFields });
    setMessage({ additionalFields: newMsgs });

    dispatch({
      type: "ADDITIONAL_FIELDS",
      payload: { value: newFields, name: "additionalFields" },
    });

    disaptchMessage({
      type: "MESSAGE_UPDATE",
      payload: {
        value: newMsgs.some((m) => m !== "")
          ? { additionalFields: newMsgs }
          : {},
        key: "additionalFields",
      },
    });
  }

  // ----------------------------
  // ADD FIELD
  // ----------------------------
  function handleAddFields() {
    let allFilled = true;
    let emptyIndex = -1;

    inputValue.additionalFields.forEach((field, index) => {
      if ((!field.key || !field.value) && emptyIndex === -1) {
        emptyIndex = index;
        allFilled = false;
      }
    });

    if (allFilled) {
      const newFields = [
        ...inputValue.additionalFields,
        { key: "", value: "" },
      ];
      const newMsgs = [...message.additionalFields, ""];

      setInputValue({ additionalFields: newFields });
      setMessage({ additionalFields: newMsgs });
    } else {
      setMessage((prev) => {
        const updated = [...prev.additionalFields];
        updated[emptyIndex] =
          "Please fill this field before adding another one.";
        return { additionalFields: updated };
      });
    }
  }

  return (
    <Paper>
      <Grid size={12}>
        <ComponentHeader
          title="Additional Field"
          subtitle="Not able to find desired audience field? Add them."
          buttons={[
            <Button
              onClick={handleAddFields}
              variant="contained"
              disabled={!editState}
            >
              Add Additional Field
            </Button>,
          ]}
        />
      </Grid>

      {inputValue.additionalFields.map((_, index) => (
        <Fragment key={index}>
          <Grid size={10}>
            <Typography variant="h6">Additional Field {index + 1}</Typography>
          </Grid>

          <Grid size={5}>
            <TextField
              size="small"
              value={inputValue.additionalFields[index]?.key}
              disabled={!editState}
              placeholder="Key"
              label="Key"
              onBlur={handleBlur}
              onChange={(e) => {
                const newFields = [...inputValue.additionalFields];
                newFields[index] = {
                  ...newFields[index],
                  key: e.target.value,
                };
                setInputValue({ additionalFields: newFields });
                checkValidation(index);
              }}
            />
          </Grid>

          <Grid size={5}>
            <TextField
              size="small"
              value={inputValue.additionalFields[index]?.value}
              disabled={!editState}
              placeholder="Value"
              label="Value"
              onBlur={handleBlur}
              onChange={(e) => {
                const newFields = [...inputValue.additionalFields];
                newFields[index] = {
                  ...newFields[index],
                  value: e.target.value,
                };
                setInputValue({ additionalFields: newFields });
                checkValidation(index);
              }}
            />
          </Grid>

          {editState && (
            <Grid size={2} alignSelf="center">
              <Tooltip title={"Delete additional field " + (index + 1)}>
                <IconButton
                  style={{ color: colors.error }}
                  onClick={() => handleDelete(index)}
                >
                  <DeleteOutline />
                </IconButton>
              </Tooltip>
            </Grid>
          )}

          <Grid size={12}>
            <Typography variant="caption" color={colors.error}>
              {message.additionalFields[index]}
            </Typography>
          </Grid>
        </Fragment>
      ))}
    </Paper>
  );
}
